import algeriaFlag from '@/assets/flags/algeria.png'
import argentinaFlag from '@/assets/flags/argentina.png'
import boliviaFlag from '@/assets/flags/bolivia.png'
import brazilFlag from '@/assets/flags/brazil.png'
import chileFlag from '@/assets/flags/chile.png'
import colombiaFlag from '@/assets/flags/colombia.png'
import ecuadorFlag from '@/assets/flags/ecuador.png'
import moroccoFlag from '@/assets/flags/morocco.png'
import peruFlag from '@/assets/flags/peru.png'
import southAmericaFlag from '@/assets/flags/south-america.png'
import tunisiaFlag from '@/assets/flags/tunisia.png'
import usaFlag from '@/assets/flags/usa.png'
import usafricomLogo from '@/assets/logos/usafricom-logo.png'
import usfsLogo from '@/assets/logos/usfs-logo.png'
import areas, { filterAreas } from '@/constants/areas/index.ts'
import { northAfricaLayers } from '@/constants/layers/region/northAfrica/northAfricaLayers'
import { northAmericaLayers } from '@/constants/layers/region/northAmerica/northAmericaLayers'
import { southAmericaLayers } from '@/constants/layers/region/southAmerica/southAmericaLayers'
import { tenantOrgIds } from '@/customers/tenantOrgIds'
import type { Customer } from '@/types/Customer'
import { mergeTocs } from '@/utils/layers.ts'
/**
 * Factory function to create a customer with default logo
 */
const createCustomer = (config: Omit<Customer, 'logo'> & { logo?: Customer['logo'] }): Customer => ({
  logo: 'technosylva',
  ...config
})
///////////// CONUS /////////////
const conus: Customer = createCustomer({
  extent: {
    xmax: -6147654.7597313,
    xmin: -15266286.486037262,
    ymax: 6943638.847989451,
    ymin: 2217996.0112879705
  },
  area: areas.conusArea,
  filterArea: filterAreas.conusFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.conus,
  toc: mergeTocs(northAmericaLayers),
  extraLogos: [{ src: usaFlag, altKey: 'views.map.logos.usaFlag' }]
})

///////////// SOUTH AMERICA /////////////
const southAmerica: Customer = createCustomer({
  extent: {
    xmax: 1699064.815909667,
    xmin: -16538198.636702256,
    ymax: 1948937.671724225,
    ymin: -7502348.001678737
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.southAmerica,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: southAmericaFlag, altKey: 'views.map.logos.southAmericaFlag' }]
})

const argentina: Customer = createCustomer({
  extent: {
    xmax: -5970843.527678816,
    xmin: -8188661.742753205,
    ymax: -2485251.888113082,
    ymin: -7373713.980971952
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.argentina,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: argentinaFlag, altKey: 'views.map.logos.argentinaFlag' }]
})

const bolivia: Customer = createCustomer({
  extent: {
    xmax: -6395638.704545947,
    xmin: -7752400.658334365,
    ymax: -1082622.8916163188,
    ymin: -2619446.432653494
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.bolivia,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: boliviaFlag, altKey: 'views.map.logos.boliviaFlag' }]
})

const chile: Customer = createCustomer({
  extent: {
    xmax: 1699064.815909667,
    xmin: -16538198.636702256,
    ymax: 1948937.671724225,
    ymin: -7502348.001678737
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.chile,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: chileFlag, altKey: 'views.map.logos.chileFlag' }]
})

const colombia: Customer = createCustomer({
  extent: {
    xmax: -6279657.23412287,
    xmin: -9841011.255984854,
    ymax: 1450438.9586099163,
    ymin: -562606.6183079506
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.colombia,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: colombiaFlag, altKey: 'views.map.logos.colombiaFlag' }]
})

const brazil: Customer = createCustomer({
  extent: {
    xmax: -2023112.825432607,
    xmin: -10554708.174508572,
    ymax: 974527.0940271285,
    ymin: -3937010.595463851
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.brazil,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: brazilFlag, altKey: 'views.map.logos.brazilFlag' }]
})

const ecuador: Customer = createCustomer({
  extent: {
    xmax: -7737685.160370192,
    xmin: -9723824.903331684,
    ymax: 339042.8904468736,
    ymin: -778772.2111952468
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.ecuador,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: ecuadorFlag, altKey: 'views.map.logos.ecuadorFlag' }]
})

const peru: Customer = createCustomer({
  extent: {
    xmax: -6184884.127222467,
    xmin: -10157163.61314545,
    ymax: 196290.46989936917,
    ymin: -2039339.7333848716
  },
  area: areas.southAmericaArea,
  filterArea: filterAreas.southAmericaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.peru,
  toc: mergeTocs(southAmericaLayers),
  extraLogos: [{ src: peruFlag, altKey: 'views.map.logos.peruFlag' }]
})

///////////// AFRICA /////////////
const algeria: Customer = createCustomer({
  extent: {
    xmax: 1335767.1,
    xmin: -965540.74,
    ymax: 4452203.33,
    ymin: 2150227.13
  },
  area: areas.algeriaArea,
  filterArea: filterAreas.algeriaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.algeria,
  dateFormat: 'dd/MM/yyyy',
  toc: mergeTocs(northAfricaLayers),
  extraLogos: [{ src: algeriaFlag, altKey: 'views.map.logos.algeriaFlag' }]
})

const tunisia: Customer = createCustomer({
  extent: {
    xmax: 4059268.536931945,
    xmin: -2016557.9673985608,
    ymax: 4582260.662339937,
    ymin: 1321762.783808309
  },
  area: areas.tunisiaArea,
  filterArea: filterAreas.tunisiaFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.tunisia,
  toc: mergeTocs(northAfricaLayers),
  extraLogos: [{ src: tunisiaFlag, altKey: 'views.map.logos.tunisiaFlag' }]
})

const morocco: Customer = createCustomer({
  extent: {
    xmax: 4059268.536931945,
    xmin: -2016557.9673985608,
    ymax: 4582260.662339937,
    ymin: 1321762.783808309
  },
  area: areas.moroccoArea,
  filterArea: filterAreas.moroccoFilterArea,
  trimLayers: true,
  orgId: tenantOrgIds.morocco,
  toc: mergeTocs(northAfricaLayers),
  extraLogos: [{ src: moroccoFlag, altKey: 'views.map.logos.moroccoFlag' }]
})

const usafricom: Customer = createCustomer({
  extent: {
    xmax: 4059268.536931945,
    xmin: -2016557.9673985608,
    ymax: 4582260.662339937,
    ymin: 1321762.783808309
  },
  // area: JSON.stringify(southAmericaArea),
  // No area of its own: trimmed to the areas of its hierarchy (Algeria, Tunisia, Morocco)
  trimLayers: true,
  orgId: tenantOrgIds.usafricom,
  toc: mergeTocs(northAfricaLayers),
  extraLogos: [
    { src: usfsLogo, altKey: 'views.map.logos.usfsSeal' },
    { src: usafricomLogo, altKey: 'views.map.logos.africomSeal' }
  ]
})

///////////// TECHNOSYLVA /////////////
const technosylva: Customer = createCustomer({
  extent: {
    xmax: 1699064.815909667,
    xmin: -16538198.636702256,
    ymax: 1948937.671724225,
    ymin: -7502348.001678737
  },
  orgId: tenantOrgIds.technosylva
})

export default [
  southAmerica,
  argentina,
  bolivia,
  chile,
  brazil,
  colombia,
  peru,
  ecuador,
  conus,
  technosylva,
  algeria,
  tunisia,
  morocco,
  usafricom
] as const satisfies readonly Customer[]
